module.exports = __webpack_public_path__ + "static/media/game2.52bdb906.svg";